import { useEffect, useState } from 'react';
import { Typography, Box, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const LoadingOverlay = ({ spinner, text, onStop }) => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4); // Cycle 0 → 1 → 2 → 3 → 0
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 10,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        pointerEvents: 'auto',
        backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent white background
      }}
    >
      {onStop && (
        <Tooltip title="Cancel">
          <IconButton
            onClick={onStop}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: '#212B36',
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      )}
      {spinner}
      <Box sx={{}}>
        <Typography sx={{ fontSize: '1.2rem', mt: 2 }}>
          {text}
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              width: '1.5ch', // enough space for 3 dots
              textAlign: 'left',
              whiteSpace: 'pre', // preserve dot spacing
            }}
          >
            {'.'.repeat(dotCount)}
          </Box>
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingOverlay;
